var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeLayout === 1
    ? _c(
        "div",
        { staticClass: "main-content", attrs: { id: "layout-one" } },
        [
          _c(
            "keep-alive",
            [_c(_vm.activeTab.component, { tag: "component" })],
            1
          )
        ],
        1
      )
    : _vm.activeLayout === 2
    ? _c("div", { staticClass: "main-content", attrs: { id: "layout-two" } }, [
        _c("div", { staticClass: "half-tab" }, [_c("HomeTab")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "half-tab" },
          [
            _vm.spaceIsOccupied("space2Tab")
              ? _c(_vm.space2Tab.component, { tag: "component" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpaceTabSelection(2)
              ? _c("tab-selection", {
                  attrs: { openTabs: _vm.unusedOpenTabs },
                  on: {
                    selectTab: function($event) {
                      return _vm.selectSpaceTab($event, 2, 2)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm.activeLayout === 3
    ? _c(
        "div",
        { staticClass: "main-content", attrs: { id: "layout-three" } },
        [
          _c("div", { staticClass: "half-tab" }, [_c("HomeTab")], 1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "quarter-tab" },
            [
              _vm.spaceIsOccupied("space2Tab")
                ? _c(_vm.space2Tab.component, { tag: "component" })
                : _vm._e(),
              _vm._v(" "),
              _vm.showSpaceTabSelection(2)
                ? _c("tab-selection", {
                    attrs: { openTabs: _vm.unusedOpenTabs },
                    on: {
                      selectTab: function($event) {
                        return _vm.selectSpaceTab($event, 3, 2)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "quarter-tab" },
            [
              _vm.spaceIsOccupied("space3Tab")
                ? _c(_vm.space3Tab.component, { tag: "component" })
                : _vm._e(),
              _vm._v(" "),
              _vm.showSpaceTabSelection(3)
                ? _c("tab-selection", {
                    attrs: { openTabs: _vm.unusedOpenTabs },
                    on: {
                      selectTab: function($event) {
                        return _vm.selectSpaceTab($event, 3, 3)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm.activeLayout === 4
    ? _c("div", { staticClass: "main-content", attrs: { id: "layout-four" } }, [
        _c("div", { staticClass: "quarter-tab" }, [_c("HomeTab")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "quarter-tab" },
          [
            _vm.spaceIsOccupied("space2Tab")
              ? _c(_vm.space2Tab.component, { tag: "component" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpaceTabSelection(2)
              ? _c("tab-selection", {
                  attrs: { openTabs: _vm.unusedOpenTabs },
                  on: {
                    selectTab: function($event) {
                      return _vm.selectSpaceTab($event, 4, 2)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "quarter-tab" },
          [
            _vm.spaceIsOccupied("space3Tab")
              ? _c(_vm.space3Tab.component, { tag: "component" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpaceTabSelection(3)
              ? _c("tab-selection", {
                  attrs: { openTabs: _vm.unusedOpenTabs },
                  on: {
                    selectTab: function($event) {
                      return _vm.selectSpaceTab($event, 4, 3)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "quarter-tab" },
          [
            _vm.spaceIsOccupied("space4Tab")
              ? _c(_vm.space4Tab.component, { tag: "component" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpaceTabSelection(4)
              ? _c("tab-selection", {
                  attrs: { openTabs: _vm.unusedOpenTabs },
                  on: {
                    selectTab: function($event) {
                      return _vm.selectSpaceTab($event, 4, 4)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c23f5aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c23f5aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/MainContent.vue
// module id = null
// module chunks = 